import http from '@/requests/http'

class Node {
  static findAll (params) {
    return http.post('servers/nodes', params)
  }
  static store (params) {
    return http.post('servers/nodes/store', params)
  }
  static view (params) {
    return http.post('servers/nodes/view', params)
  }
  static update (params) {
    return http.post('servers/nodes/update', params)
  }
  static destroy (params) {
    return http.post('servers/nodes/destroy', params)
  }
  static getQueueStatusNodeByLoggedInUser () {
    return http.post('servers/nodes/get-queue-status-node-by-logged-in-user')
  }
  static getServerAndNodeByLoggedInUser () {
    return http.post('servers/nodes/get-server-and-node-by-logged-in-user')
  }
  static getCallListenerNodeByLoggedInUser () {
    return http.post('servers/nodes/get-call-listener-node-by-logged-in-user')
  }
}

export default Node
